/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { TranslationService } from '@gh/core-mls';
import { GridOptionsExt, ManualGridDefinition } from '@gh/core-ui-grid';

import { ColDef, TooltipParams } from 'ag-grid-community';

@Injectable()
export class UsageDialogGridDefinition extends ManualGridDefinition {

  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'entityType',
      headerName: this.translationService.get('lbl_used_by'),
      width: 200,
    },
      {
        field: 'entityName',
        headerName: this.translationService.get('lbl_details'),
        width: 700,
        tooltip: ({ value }: TooltipParams) => value || '',
      }];
  }

  buildGridOptions(): GridOptionsExt {
    return { noAutomation: true };
  }
}
